export default "__VITE_ASSET__85e5f29d__"